import {bootstrap, IBootstrap, inject} from '@injex/core';
import {RenderInjexProvider} from '@injex/react-plugin';
import {UIKitProvider} from "@vidazoo/ui-kit";
import {Link} from "react-router-dom";
import {Auth0Provider} from '@auth0/auth0-react';
import AuthGate from './modules/session/components/auth-gate/AuthGate';

@bootstrap()
export class Bootstrap implements IBootstrap {
    @inject() private renderInjexProvider: RenderInjexProvider;

    public run() {
        const apis = (window as any).apis || {};

        this.renderInjexProvider(
            <UIKitProvider config={{linkComponent: Link, baseAppTitle: 'vidazoo bi-dashboard'}}>
                <Auth0Provider
                    domain={apis.authDomain || 'perion-one-dev.us.auth0.com'}
                    clientId={apis.authClientId || 'MSzrFAiBz53RC1bsR3uKkYoQ7H8uAJd7'}
                    authorizationParams={{
                        scope: 'openid profile email read:data',
                        audience: apis.authAudience || 'http://supply-bo',
                        redirect_uri: window.location.origin
                    }}
                >
                    <AuthGate/>
                </Auth0Provider>
            </UIKitProvider>
        );
    }
}
